'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPageOfMessagesToThreadHistory = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _mergeMessages = require('./mergeMessages');

var _sortMessages = require('./sortMessages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add a new page of messages to a Threadhistory
 *
 * @param {ThreadHistory} newThreadHistory
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */
var addPageOfMessagesToThreadHistory = exports.addPageOfMessagesToThreadHistory = (0, _curry2.default)(function (newThreadHistory, threadHistory) {
  (0, _threadHistoryInvariant.threadHistoryInvariant)(newThreadHistory);
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);
  return (0, _pipe2.default)((0, _mergeMessages.mergeMessages)(threadHistory.messages), _sortMessages.sortMessages)(newThreadHistory);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/addPageOfMessagesToThreadHistory.js
// module id = 885
// module chunks = 2 3